import React from 'react';
import Container from "react-bootstrap/Container";

function Footer() {
    return (
        <footer className="fixed-bottom bg-light text-dark text-center py-3 mt-auto">
            <Container>
                &copy; {new Date().getFullYear()} Diataxi. All rights reserved.
            </Container>
        </footer>
    );
}

export default Footer;